var _circle, _g, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _path, _path2, _path3, _circle24, _circle25, _circle26, _circle27, _circle28;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNubeDataBlack = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 1024 768",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 477.5,
    cy: 492.8,
    r: 28.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 313.3,
    cy: 596.6,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.9,
    cy: 568.7,
    r: 9.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.8,
    cy: 535,
    r: 13.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 494.3,
    r: 18.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.4,
    cy: 571.4,
    r: 18.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.3,
    cy: 531.2,
    r: 23.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.7,
    cy: 599.3,
    r: 13.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.8,
    cy: 610,
    r: 13.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.2,
    cy: 571.4,
    r: 18.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.7,
    cy: 641,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.5,
    cy: 652.8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.5,
    cy: 628.2,
    r: 8.6
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 582.7,
    cy: 655,
    r: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.9,
    cy: 631.4,
    r: 9.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 521.1,
    cy: 602.5,
    r: 13.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.4,
    cy: 537.9,
    r: 23.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 585.4,
    cy: 536.6,
    r: 13.9
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.1,
    cy: 609.4,
    r: 13.9
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.7,
    cy: 573,
    r: 18.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.4,
    cy: 640.5,
    r: 8.6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 639,
    cy: 598.7,
    r: 7.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 616.5,
    cy: 569.8,
    r: 8.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.7,
    cy: 326,
    r: 8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.6,
    cy: 351.7,
    r: 9.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.2,
    cy: 380.7,
    r: 13.9
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.8,
    cy: 449.5,
    r: 23.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.9,
    cy: 444.4,
    r: 13.9
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.4,
    cy: 371.6,
    r: 13.9
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.8,
    cy: 408,
    r: 18.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.4,
    cy: 338.4,
    r: 8.6
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 382.3,
    r: 7.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 339,
    cy: 411.2,
    r: 8.6
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 642.2,
    cy: 384.4,
    r: 8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 616.5,
    cy: 414.4,
    r: 9.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 587.6,
    cy: 446,
    r: 13.9
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 551.7,
    cy: 493.2,
    r: 18.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458.5,418.2c0-10.1,8.2-18.2,18.2-18.2s18.2,8.2,18.2,18.2c0,10.1-8.2,18.2-18.2,18.2-10.1,0-18.2-8.2-18.2-18.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M494.9,447.6c0-13.2,10.7-23.8,23.8-23.8,13.2,0,23.8,10.7,23.8,23.8,0,13.2-10.7,23.8-23.8,23.8-13.2,0-23.8-10.7-23.8-23.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M509.9,379.6c0-7.7,6.2-13.9,13.9-13.9s13.9,6.2,13.9,13.9c0,7.7-6.2,13.9-13.9,13.9-7.7,0-13.9-6.2-13.9-13.9Z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.8,
    cy: 372.1,
    r: 13.9
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 560.3,
    cy: 409.6,
    r: 18.2
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 632,
    cy: 344.2,
    r: 8.6
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 588.1,
    cy: 328.2,
    r: 7.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.2,
    cy: 350.7,
    r: 8.6
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNubeDataBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nube-data-black.0d4b5f00.svg";
export { ForwardRef as ReactComponent };